import { useGetIsUngated, useGetHasScope, useGetLimit } from 'automation-ui-core/hooks/authHooks';
import WorkflowCreationButton from 'automation-ui-template/components/WorkflowCreationButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FlowLimitsButton(props) {
  const isUngated = useGetIsUngated();
  const hasScope = useGetHasScope();
  const getLimit = useGetLimit();
  return /*#__PURE__*/_jsx(WorkflowCreationButton, Object.assign({}, props, {
    isUngated: isUngated,
    hasScope: hasScope,
    getLimit: getLimit
  }));
}